import React, { useContext, useEffect, useState } from 'react';

// Hooks
import { useTranslation } from 'react-i18next';
import useHttp from '../../../hooks/useHttp';

// Components
import CancelConfirmButtons from '../../UI/CancelConfirmButtons/CancelConfirmButtons';
import RowButtonsFilter from '../../PatientsPage/RowButtonsFilter/RowButtonsFilter';
import { getEnvironmentApiUrl } from '../../../services/General';
import { DeviceType } from '../../../interfaces/Device';
import ErrorSpinnerWrapper from '../../UI/ErrorSpinnerWrapper.tsx/ErrorSpinnerWrapper';
import FiltersContext from '../../../context/FiltersContext';

// Interfaces
interface Props {
    modalShow?: React.Dispatch<React.SetStateAction<boolean>>;
    setFilterBallActive?: (isActive: boolean) => void
    defaultProfiles?: number[]
    defaultIsLent?: boolean | null
    defaultDeviceType?: number[]
    handleConfirm: (selectedProfiles: number[], isLent: boolean | null, selectedDeviceTypes: number[]) => void
}

const DialogFilterDevice: React.FC<Props> = ({ modalShow, setFilterBallActive, defaultProfiles, defaultIsLent, defaultDeviceType, handleConfirm }) => {

    const { t } = useTranslation();

    const { isLoading, error, sendRequest } = useHttp<DeviceType[]>();

    const { profiles } = useContext(FiltersContext);

    const [selectedProfiles, setSelectedProfiles] = useState(defaultProfiles ?? []);
    const [selectedStatus, setSelectedStatus] = useState<number[]>(defaultIsLent === null ? [] : defaultIsLent ? [1] : [0]);
    const [selectedDevices, setSelectedDevices] = useState<number[]>(defaultDeviceType ?? []);
    const [deviceOptions, setDeviceOptions] = useState<{ id: number, content: string }[]>([]);

    const handleClickState = (id: number) => {
        setSelectedStatus(oldState => oldState.includes(id) ? [] : [id])
    }

    const handleClickDevice = (id: number) => {
        setSelectedDevices(oldState => oldState.includes(id) ?
            oldState.filter(oldID => oldID !== id) : [...oldState, id]
        )
    }

    const handleClickProfile = (id: number) => {
        setSelectedProfiles(oldState => oldState.includes(id) ?
            oldState.filter(oldID => oldID !== id) : [...oldState, id]
        )
    }

    useEffect(() => {
        sendRequest({
            url: getEnvironmentApiUrl() + 'device_type/all',
            method: 'POST',
            body: { params: {}, filter: {} }
        }, (data) => {
            setDeviceOptions(data.map(d => ({ id: d.id, content: d.name ?? '' })))
        })
    }, [sendRequest]);

    const onConfirm = () => {
        setFilterBallActive?.(selectedProfiles.length !== 0 || selectedStatus.length !== 0 || selectedDevices.length !== 0)
        handleConfirm(selectedProfiles, selectedStatus.length === 0 || selectedStatus.length === 2 ? null : selectedStatus.includes(1), selectedDevices);
        modalShow?.(false);
    }

    const environmentOptions = profiles.map(p => (
        { id: p.id, content: p.name }
    ));

    const OPTIONS_STATE = [{ id: 0, content: t('available') }, { id: 1, content: t('lent') }]

    return (
        <div className='dialog'>
            <h1 className='dialogTitle'>{t('filter')}</h1>
            <ErrorSpinnerWrapper loading={isLoading} error={error}>
                <RowButtonsFilter
                    text={t('status')}
                    currentFilters={selectedStatus}
                    content={OPTIONS_STATE}
                    handleClick={handleClickState}
                />
                <RowButtonsFilter
                    text={t('device_type')}
                    currentFilters={selectedDevices}
                    content={deviceOptions}
                    handleClick={handleClickDevice}
                />
                <RowButtonsFilter
                    text={t('environment')}
                    currentFilters={selectedProfiles}
                    content={environmentOptions}
                    handleClick={handleClickProfile}
                />
            </ErrorSpinnerWrapper>
            <CancelConfirmButtons
                onCancel={() => modalShow?.(false)}
                onConfirm={onConfirm}
            />
        </div>
    );
};

export default DialogFilterDevice;